import { Panel } from './Panel';

const fmt = (v) => (v === null || v === undefined ? '—' : v);

export const EventLog = ({ events }) => {
  const t0 = events.length ? events[events.length - 1].t : 0;
  return (
    <Panel testId="event-log-panel" code="08 / RAW STREAM" title="Raw Event Log · last 50" delay={420} right={<span data-testid="event-log-count" className="text-xs text-[var(--muted)]">{events.length} EVENTS</span>}>
      <div data-testid="raw-midi-log-container" className="log-scroll h-[340px] overflow-y-auto border border-[var(--hair)] bg-[#03060a]">
        <table className="w-full text-left text-xs tabular-nums">
          <thead className="sticky top-0 bg-[#0a0f15] text-[var(--muted)]">
            <tr>
              {['#', 'T+ms', 'SRC', 'TYPE', 'CH', 'NOTE', 'VEL', 'CC#', 'VAL'].map((h) => (
                <th key={h} className="px-3 py-2 font-normal tracking-[0.15em]">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {events.map((e) => (
              <tr key={e.id} data-testid="event-log-row" className="border-t border-white/5">
                <td className="px-3 py-1 text-[var(--dim)]">{e.id}</td>
                <td className="px-3 py-1 text-[var(--muted)]">{Math.round(e.t - t0)}</td>
                <td className={`px-3 py-1 ${e.src === 'sim' ? 'text-[var(--amber)]' : 'text-[var(--spore)]'}`}>{e.src === 'sim' ? 'SIM' : 'MIDI'}</td>
                <td className={`px-3 py-1 ${e.type === 'cc' ? 'text-[var(--teal)]' : e.type === 'note_on' ? 'text-[var(--spore)]' : 'text-[var(--muted)]'}`}>{e.type}</td>
                <td className="px-3 py-1">{e.channel}</td>
                <td className="px-3 py-1">{fmt(e.note)}</td>
                <td className="px-3 py-1">{fmt(e.velocity)}</td>
                <td className="px-3 py-1">{fmt(e.cc)}</td>
                <td className="px-3 py-1">{fmt(e.value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!events.length && <div className="p-6 text-sm text-[var(--dim)]">Awaiting signal… connect the Biotron or enable the simulator (S).</div>}
      </div>
    </Panel>
  );
};
